import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import NomineeView from './components/NomineeView';
import ThankYou from './components/ThankYou';
import MyVotes from './components/MyVotes';
import reportWebVitals from './reportWebVitals';

const path      = window.location.pathname;
const voteRoute = path.match(/^\/vote\/([^/]+)\/?$/);
const isThankYou = path === '/thank-you' || path === '/thank-you/';
const isMyVotes  = path === '/my-votes' || path === '/my-votes/';

const RootComponent = voteRoute
  ? () => <NomineeView code={voteRoute[1]} />
  : isThankYou
  ? ThankYou
  : isMyVotes
  ? MyVotes
  : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
